<template>
  <div>
    <div class="bg-purple">
      <form-build-component
        form-name="customerForm"
        :form-data="customerForm"
        :form-columns-group="customerFormColumnsGroup"
        :form-rules="customerFormRules"
        :form-buttons="customerFormButtons"
      ></form-build-component>
    </div>
    <button-back/>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import FormBuildComponent from "../../../components/FormBuild";
  import { provinceAndCityData, CodeToText, TextToCode } from 'element-china-area-data'
  import sexOptions from '../../../utils/sexOptions'
  import ButtonBack from "../../../components/ButtonBack";

  export default {
    name: "CustomerEdit",
    components: {ButtonBack, FormBuildComponent},
    data() {
      return {
        customerId: this.$route.query['c.customerId']||'',
        customerForm: {
          "u__email": "",
          "c__customerName": "",
          "i__provinceAndCity": [],
          "i__province": "",
          "i__city": "",
          "i__address": "",
          "i__socialIdentityCode": "",
          "i__registeredCapital": "",
          "i__bizlicValidity": [],
          "i__bizlicValidity1": "",
          "i__bizlicValidity2": "",
          "i__bizlicURL": "",
          "i__contactPerson": "",
          "i__contactSex": "",
          "i__contactTelNo": "",
          "i__contactTelNo2": "",
          "i__contactFaxNo": "",
          "i__contactEmail": "",
          "i__industry": "",
          "i__bizrep": "",
          "i__bizrepIC": "",
          "i__bizrepICValidity": [],
          "i__bizrepICValidity1": "",
          "i__bizrepICValidity2": "",
          "i__bizrepLocation": "",
          "i__bizrepICURL1": "",
          "i__bizrepICURL2": "",
          "i__bizrepICURL3": "",
          "i__remarks": ""
        },
        customerFormRules: {
          "mobileNo": [
            {
              required: true,
              message: '手机号不能为空'
            },
            {
              type: 'number',
              message: '请输入11位数字的手机号'
            }
          ],
          c__customerName: [
            {
              required: true,
              message: '企业名称不能为空！'
            }
          ],
          i__socialIdentityCode: [
            {
              required: true,
              message: '社会信用代码不能为空！'
            },
          ],
          i__provinceAndCity: [
            {
              required: true,
              message: '单位所在地不能为空！'
            }
          ],
          i__bizrep: [
            {
              required: true,
              message: '法人姓名不能为空！'
            }
          ],
          i__contactPerson:[
            {
              required: true,
              message: '联系人不能为空！'
            }
          ],
          i__contactTelNo: [
            {
              required: true,
              message: '联系人手机号不能为空！'
            }
          ],
        },

        customerFormColumnsGroup: [
          {
            label: '企业信息',
            columns: [
              {
                label: '企业名称',
                component: 'el-input',
                field: 'c__customerName',
              },
              {
                label: '统一社会信用代码',
                component: 'el-input',
                field: 'i__socialIdentityCode',
                maxLength: "18",
              },
              {
                label: '单位所在地',
                component: 'el-cascader',
                field: 'i__provinceAndCity',
                options: provinceAndCityData,
              },
              {
                label: '营业期限',
                component: 'date-range-picker',
                field: 'i__bizlicValidity',
              },
              {
                label: '住所',
                component: 'el-input',
                field: 'i__address',
                span: 24
              }
            ]
          },
          {
            label: '法人信息',
            columns: [
              {
                label: '法人姓名',
                component: 'el-input',
                field: 'i__bizrep'
              },
              {
                label: '证件类型',
                component: 'el-select',
                options: [
                  {
                    label: '身份证',
                    key: '身份证',
                    value: '身份证'
                  },
                  {
                    label: '护照',
                    key: '护照',
                    value: '护照'
                  },
                  {
                    label: '台胞证',
                    key: '台胞证',
                    value: '台胞证'
                  }
                ],
                field: 'i__bizrepType'
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'i__bizrepMobile'
              },
              {
                label: '证件号码',
                component: 'el-input',
                field: 'i__bizrepIC'
              },
              {
                label: '证件有效期',
                component: 'date-range-picker',
                field: 'i__bizrepICValidity',
              },
            ]
          },
          {
            label: '联系人信息',
            columns: [
              {
                label: '姓名',
                component: 'el-input',
                field: 'i__contactPerson'
              },
              {
                label: '性别',
                component: 'el-select',
                field: 'i__contactSex',
                options: sexOptions
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'i__contactTelNo'
              },
              {
                label: '固定电话',
                component: 'el-input',
                field: 'i__contactTelNo2'
              },
              {
                label: '邮箱',
                component: 'el-input',
                field: 'i__contactEmail'
              },
              {
                label: '传真',
                component: 'el-input',
                field: 'i__contactFaxNo'
              }
            ]
          },
          {
            label: '证件信息',
            columns: [
              {
                label: '营业执照',
                component: 'image-upload',
                field: 'i__bizlicURL',
                span: 24,
              },
              {
                label: '法人证件照头像页',
                component: 'image-upload',
                field: 'i__bizrepICURL1',
                span: 24
              },
              {
                label: '法人证件照国徽页',
                component: 'image-upload',
                field: 'i__bizrepICURL2',
                span: 24
              }
            ]
          }
        ],
        customerFormButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler: (refs)=>{
              this.onSubmit(refs)
            }
          },
          {
            label: '重置',
            clickHandler: (refs)=>{
              refs.resetFields()
            }
          }
        ]
      }
    },
    mounted() {
      this.getCustomerDetail()
    },
    computed: {
      i__provinceAndCity: function () {
        return this.customerForm.i__provinceAndCity
      },
      i__bizlicValidity: function () {
        return this.customerForm.i__bizlicValidity
      },
      i__bizrepICValidity: function () {
        return this.customerForm.i__bizrepICValidity
      }
    },
    watch: {
      i__provinceAndCity : function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          [this.customerForm.i__province,
            this.customerForm.i__city]
            = newVal.map(item => CodeToText[item])
        }
      },
      i__bizlicValidity: function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          [this.customerForm.i__bizlicValidity1,
            this.customerForm.i__bizlicValidity2]
            = newVal
        }

      },
      i__bizrepICValidity: function (newVal, oldVal) {
        if (Array.isArray(newVal)) {
          [this.customerForm.i__bizrepICValidity1,
            this.customerForm.i__bizrepICValidity2]
            = newVal
        }
      }
    },
    methods: {
      getCustomerDetail: function (customerId = this.customerId) {
        xhr.getCustomerDetail(
          {
            'c.customerId': customerId
          },
          res=> {
            try {
              if(res.data.status == 'success') {
                this.customerForm = res.data.data

                let provinceAndCityArray = [
                  TextToCode[this.customerForm.i__province],
                  TextToCode[this.customerForm.i__province][this.customerForm.i__city]
                ]
                this.customerForm.i__provinceAndCity = provinceAndCityArray.map(item=>item.code)
                this.customerForm.i__bizlicValidity = [this.customerForm.i__bizlicValidity1, this.customerForm.i__bizlicValidity2]
                this.customerForm.i__bizrepICValidity = [this.customerForm.i__bizrepICValidity1, this.customerForm.i__bizrepICValidity2]
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function ($refs) {
        $refs.validate(valid=>{
          if(valid) {
            console.log('customerForm', this.customerForm)
            xhr.updateCustomerDetail(
              this.customerForm,
              res=>{
                try {
                  if(res.data.status == 'success') {

                  }
                }catch (e) {

                }
              }
            )
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerEdit.vue